<script lang="ts" setup>
  import {
    DatePicker,
    DROPDOWN_CONTEXT_KEY,
    DropdownApplyFooter,
    DropdownPanelScroll,
  } from '@tundr/ds-components';
  import { computed, inject, ref, watch } from 'vue';
  import { singleDateFilterWrapperClass } from './SingleDateFilter.css';
  import { useFilters } from '../../../../composables';
  import { FilterTypes } from '../../../../utils';
  import { useLocale } from '@tundr/i18n';

  const props = defineProps<{
    filterNamespace: string;
    filterLabel: string;
    filterFieldName: string;
    min?: Date;
    max?: Date;
    modelValue?: Date | null;
  }>();

  defineOptions({
    inheritAttrs: false,
  });

  const { t } = useLocale('table');

  const dropdown = inject(DROPDOWN_CONTEXT_KEY, null);

  const currentFilterStore = useFilters(props.filterNamespace);

  const date = ref<Date>(props.modelValue as Date);

  watch(
    () => props.modelValue,
    (value) => {
      date.value = value as Date;
    },
  );

  const emit = defineEmits<{
    'update:modelValue': [date: Date | null];
  }>();

  const onApplyFilter = () => {
    emit('update:modelValue', date.value);
    currentFilterStore.applyFilterValue({
      filterFieldName: props.filterFieldName,
      value: date.value,
      filterType: FilterTypes.DATE,
    });
    dropdown?.close();
  };

  const maxDate = computed(() => {
    return (props.max as Date) || undefined;
  });

  const minDate = computed(() => {
    return (props.min as Date) || undefined;
  });
</script>

<template>
  <DropdownPanelScroll :class="singleDateFilterWrapperClass">
    <DatePicker
      v-model="date"
      :label="filterLabel"
      :name="filterFieldName"
      required
      :placeholder="t('filters.date_range.start_date.placeholder')"
      :teleport="true"
      :max-date="maxDate"
      :min-date="minDate"
    />
  </DropdownPanelScroll>
  <DropdownApplyFooter :disabled="!date" @apply="onApplyFilter" />
</template>
